module.exports = __webpack_public_path__ + "media/images/ui-alert/sweet-alert-bg-9395d14f5ca657d19a9193aad7bb8721.png";